<template>
  <v-container fill-height fluid>
    <v-row>
      <v-col cols=12 :md="split ? 6 : 4" :offset-md="split ? 3 : 4">
        <v-card elevation="2">
          <v-card-text class="pa-0">
            <v-row>
              <v-col v-if="split" cols="12" md="7" class="login-info py-0">
                <div class="pa-8 pl-4">
                  <v-img :src="$theme.assets.logoCurrent" class="text-left login-logo" :height="$theme.layout.loginLogoHeight" contain/>
                  <h2 class="pl-5 mt-4">{{ $theme.brand.tagline }}</h2>
                  <v-list dense color="transparent" class="d-none d-md-block mt-8">
                    <v-list-item v-for="bullet in $theme.brand.loginBullets" :key="bullet">
                      <v-list-item-icon>
                        <v-icon color="green">mdi-check</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        {{ bullet }}
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </v-col>
              <v-col cols="12" :md="split ? 5 : 12" class="login-form-pane">
                <component :is="formDark ? 'VThemeProvider' : 'div'" v-bind="formDark ? { dark: true } : {}">
                  <div class="pa-8">
                <v-img v-if="!split" :src="$theme.assets.logoCurrent" :height="$theme.layout.loginLogoHeight" contain class="mb-2" />
                <h1 class="text-center mt-8">Connexion</h1>
                <p class="mt-4 text-center">Accédez à votre espace {{ $theme.brand.loginName }}</p>
                <v-form @submit.prevent="submitForm">
                  <v-text-field
                    v-model="username"
                    label="Nom d'utilisateur"
                    hide-details
                    class="mt-2"
                    dense
                    outlined
                    autofocus
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    label="Mot de passe"
                    hide-details
                    class="mt-2"
                    dense
                    outlined
                    type="password"
                  ></v-text-field>
                  <v-alert
                    v-if="error"
                    type="error"
                    dense
                    text
                    class="mt-3 mb-0"
                  >{{ error }}</v-alert>
                  <v-btn
                    class="mt-4"
                    block
                    :loading="loading"
                    elevation=0
                    color="primary"
                    type="submit"
                  >
                    Se connecter
                  </v-btn>
                </v-form>
                  </div>
                </component>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { VThemeProvider } from 'vuetify/lib'
import { login } from '@/services/loginApi'
import { isSafeRedirect } from '@/router/history'

export default {
  name: 'LoginView',
  components: { VThemeProvider },
  computed: {
    formDark() { return this.$theme.layout.loginFormDark },
    split() { return this.$theme.layout.loginLayout === 'split' },
  },
  data() {
    return {
      loading: false,
      username: "",
      password: "",
      error: null,
    }
  },
  methods: {
    async submitForm() {
      this.error = null
      this.loading = true
      try {
        const data = await login(this.username.trim(), this.password)
        this.$store.commit("settings/SET_USER", data)
        await this.$store.dispatch("chat/initConversations")
        const redirect = this.$route.query.redirect
        this.$router.push(isSafeRedirect(redirect) ? redirect : '/')
      } catch (e) {
        this.error = e.message
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
.login-form-pane {
  background: var(--app-login-form-bg, transparent);
}
.login-info {
  background: var(--app-login-info-bg, #F6F6F6);
}
.login-logo .v-image__image--contain {
  background-position: left center !important;
}
</style>
